<template>
    <div class="relative">
        <input
            :type="viewPassword ? 'text' : 'password'"
            :id="id"
            :value="value"
            @input="$emit('update:value', $event.target.value)"
            :class="['t-input', hasErrors && 't-input-invalid']"
            :required="required"
            :placeholder="placeholder"
            @focus="$emit('clearErrors')"
        />
        <div
            class="text-[10px] hover:cursor-pointer absolute top-[14px] right-4"
            @click="viewPassword = !viewPassword"
        >
            <Icon size="15">
                <template v-if="viewPassword">
                    <Eye class="text-gray-500" />
                </template>
                <template v-else>
                    <EyeSlash class="text-gray-500" />
                </template>
            </Icon>
        </div>
    </div>
</template>

<script>
import { Icon } from "@vicons/utils";
import { AngleRight, Eye, EyeSlash } from "@vicons/fa";
export default {
    name: "PasswordInput",
    components: {
        Icon,
        AngleRight,
        Eye,
        EyeSlash,
    },
    props: {
        value: String,
        id: String,
        placeholder: {
            type: String,
            default: "",
        },
        required: {
            type: Boolean,
            default: false,
        },
        hasErrors: Boolean,
    },
    data() {
        return {
            viewPassword: false,
        };
    },
};
</script>
